// utils/appletIcon.js
//
// A custom applet icon is always stored at the SAME blob path
// (`<orgId>/<appletId>.png`, LacSsoController uploadappleticon), so uploading a
// new one does not change the URL and the browser keeps showing the old image
// from its cache. The Auth API stamps OrgApplets.IconTimestamp on every icon
// upload / library pick and sends it with each applet, so it is the icon's
// version: put it on the URL and the URL changes exactly when the image does.

/**
 * The icon's version for cache-busting: IconTimestamp in ms, or 0 when the
 * applet has none (never uploaded — .NET sends DateTime.MinValue, year 0001,
 * which parses negative).
 */
export function appletIconVersion(applet) {
    const t = Date.parse(applet?.iconTimestamp || '');
    return t > 0 ? t : 0;
}

/** `?v=<version>` for an icon URL, or '' when there is no version. */
export function iconVersionQuery(version) {
    return version ? `?v=${version}` : '';
}
